import type { Theme } from '@mui/material/styles'
// material-ui
import { Container, Stack, useMediaQuery } from '@mui/material'

// ==============================|| FOOTER - AUTHENTICATION ||============================== //

function AuthFooter() {
  const matchDownSM = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))

  return (
    <Container maxWidth="xl">
      <Stack
        direction={matchDownSM ? 'column' : 'row'}
        justifyContent={matchDownSM ? 'center' : 'space-between'}
        spacing={2}
        textAlign={matchDownSM ? 'center' : 'inherit'}
      >
        <Stack
          direction={matchDownSM ? 'column' : 'row'}
          spacing={matchDownSM ? 1 : 3}
          textAlign={matchDownSM ? 'center' : 'inherit'}
        ></Stack>
      </Stack>
    </Container>
  )
}

export default AuthFooter
